"use client";

import { RichText } from "@/components/ui/RichText";
import { ShowMoreContent, ShowMoreRoot, ShowMoreTrigger } from "@/components/ui/ShowMore";
import { Text } from "@/components/ui/Text";
import { useTranslations } from "@/i18n/client";
import { useLayoutEffect, useRef, useState } from "react";
import styles from "./index.module.css";

interface ProductDescriptionProps {
	descriptionHtml: string;
}

const COLLAPSED_HEIGHT = 115;

export const ProductDescription = ({ descriptionHtml }: ProductDescriptionProps) => {
	const t = useTranslations("product");
	const elementRef = useRef<HTMLDivElement | null>(null);
	const [contentHeight, setContentHeight] = useState<number>(0);

	useLayoutEffect(() => {
		if (elementRef.current) {
			setContentHeight(elementRef.current.offsetHeight);
		}
	}, []);
	return (
		<div ref={elementRef}>
			<ShowMoreRoot className={styles.showMore}>
				<ShowMoreContent fade collapsedHeight={COLLAPSED_HEIGHT}>
					<RichText
						className={styles.description}
						dangerouslySetInnerHTML={{
							__html: descriptionHtml,
						}}
					/>
				</ShowMoreContent>
				{contentHeight >= COLLAPSED_HEIGHT && (
					<ShowMoreTrigger
						className={styles.trigger}
						openText={<Text variant="body2">{t("readMore")}</Text>}
						closeText={<Text variant="body2">{t("showLess")}</Text>}
					/>
				)}
			</ShowMoreRoot>
		</div>
	);
};
